<template>
    <div slot="footer" class="page-foot__contain">
        <div class="page-foot__contain-box">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {}
</script>

<style scoped>
    .page-foot__contain{
        position: fixed;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: #28303b;
        padding: 4px;
        z-index: 3;
    }
    .page-foot__contain-box{
        zoom: 75%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
    }
</style>

